import React from "react";
import { motion } from "framer-motion";

/**
 * FadeIn — fade + slide vertical al entrar en el viewport
 * @param {string}  className  - clases del contenedor
 * @param {number}  distance   - píxeles de desplazamiento inicial (default 24)
 * @param {number}  threshold  - fracción visible para activar (default 0.15)
 */
export default function FadeIn({
    children,
    className = "",
    distance = 24,
    threshold = 0.15,
}) {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y: distance }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, ease: "easeOut" }}
            viewport={{ once: true, amount: threshold }}
        >
            {children}
        </motion.div>
    );
}
